import { defineMessages } from 'react-intl';

const modality = defineMessages({
    LIABILITYSHIFTCOUNTERFEITFRAUD: {
        id: 'ModalityOption.liabilityShiftCounterfeitFraud',
        defaultMessage: 'EMV Liability Shift Counterfeit Fraud',
    },
    LIABILITYSHIFTNONCOUNTERFEITFRAUD: {
        id: 'ModalityOption.liabilityShiftNonCounterfeitFraud',
        defaultMessage: 'EMV Liability Shift Non-Counterfeit Fraud',
    },
    OTHERFRAUDCARDPRESENT: {
        id: 'ModalityOption.otherFraudCardPresent',
        defaultMessage: 'Other Fraud - Card Present',
    },
    OTHERFRAUDCARDABSENT: {
        id: 'ModalityOption.otherFraudCardAbsent',
        defaultMessage: 'Other Fraud - Card Absent',
    },
    VISAFRAUDMONITORING: {
        id: 'ModalityOption.visaFraudMonitoring',
        defaultMessage: 'Visa Fraud Monitoring Program',
    },
    CARDRECOVERYBULLETIN: {
        id: 'ModalityOption.cardRecoveryBulletin',
        defaultMessage: 'Card Recovery Bulletin',
    },
    DECLINEDAUTHORIZATION: {
        id: 'ModalityOption.declinedAuthorization',
        defaultMessage: 'Declined Authorization',
    },
    NOAUTHORIZATION: {
        id: 'ModalityOption.noAuthorization',
        defaultMessage: 'No Authorization',
    },
    LATEPRESENTMENT: {
        id: 'ModalityOption.latePresentment',
        defaultMessage: 'Late Presentment',
    },
    INCORRECTTRANSACTIONCODE: {
        id: 'ModalityOption.incorrectTransactionCode',
        defaultMessage: 'Incorrect Transaction Code',
    },
    INCORRECTCURRENCY: {
        id: 'ModalityOption.incorrectCurrency',
        defaultMessage: 'Incorrect Currency',
    },
    INCORRECTACCOUNTNUMBER: {
        id: 'ModalityOption.incorrectAccountNumber',
        defaultMessage: 'Incorrect Account Number',
    },
    INCORRECTAMOUNT: {
        id: 'ModalityOption.incorrectAmount',
        defaultMessage: 'Incorrect Amount',
    },
    DUPLICATEPROCESSING: {
        id: 'ModalityOption.duplicateProcessing',
        defaultMessage: 'Duplicate Processing',
    },
    PAIDBYOTHERMEANS: {
        id: 'ModalityOption.paidByOtherMeans',
        defaultMessage: 'Paid by Other Means',
    },
    INVALIDDATA: {
        id: 'ModalityOption.invalidData',
        defaultMessage: 'Invalid Data',
    },
    MERCHANDISENOTRECEIVED: {
        id: 'ModalityOption.merchandiseNotReceived',
        defaultMessage: 'Merchandise/Services Not Received',
    },
    CANCELLEDRECURRING: {
        id: 'ModalityOption.cancelledRecurring',
        defaultMessage: 'Cancelled Recurring',
    },
    NOTASDESCRIBED: {
        id: 'ModalityOption.notAsDescribed',
        defaultMessage: 'Not as Described or Defective Merchandise/Services',
    },
    COUNTERFEITMERCHANDISE: {
        id: 'ModalityOption.counterfeitMerchandise',
        defaultMessage: 'Counterfeit Merchandise',
    },
    MISREPRESENTATION: {
        id: 'ModalityOption.misrepresentation',
        defaultMessage: 'Misrepresentation',
    },
    CREDITNOTPROCESSED: {
        id: 'ModalityOption.creditNotProcessed',
        defaultMessage: 'Credit Not Processed',
    },
    CANCELLEDMERCHANDISESERVICES: {
        id: 'ModalityOption.cancelledMerchandiseServices',
        defaultMessage: 'Cancelled Merchandise/Services',
    },
    ORIGINALCREDITTRANSACTIONNOTACCEPTED: {
        id: 'ModalityOption.originalCreditTransactionNotAccepted',
        defaultMessage: 'Original Credit Transaction Not Accepted',
    },
    NONRECEIPTOFCASHORLOADTRANSACTIONVALUE: {
        id: 'ModalityOption.nonReceiptOfCashOrLoadTransactionValue',
        defaultMessage: 'Non-Receipt of Cash or Load Transaction Value',
    },
    WARNINGBULLETINFILE: {
        defaultMessage: 'Warning Bulletin File',
        id: 'warningBulletinFile',
    },
    AUTHORIZATIONRELATEDCHARGEBACK: {
        defaultMessage: 'Authorization-Related Chargeback',
        id: 'authorizationRelatedChargeback',
    },
    ACCOUNTNUMBERNOTONFILE: {
        defaultMessage: 'Account Number Not on File',
        id: 'accountNumberNotOnFile',
    },
    REQUIREDAUTHORIZATIONNOTOBTAINED: {
        defaultMessage: 'Required Authorization Not Obtained',
        id: 'requiredAuthorizationNotObtained',
    },
    EXPIREDCHARGEBACKPROTECTIONPERIOD: {
        defaultMessage: 'Expired Chargeback Protection Period',
        id: 'expiredChargebackProtectionPeriod',
    },
    MULTIPLEAUTHORIZATIONREQUESTS: {
        defaultMessage: 'Multiple Authorization Requests',
        id: 'multipleAuthorizationRequests',
    },
    CARDHOLDERACTIVATEDTERMINALDEVICE: {
        defaultMessage: 'Cardholder-Activated Terminal (CAT) 3 Device',
        id: 'cardholderActivatedTerminalDevice',
    },
    POINTOFINTERACTIONERROR: {
        defaultMessage: 'Point of Interaction Error',
        id: 'pointOfInteractionError',
    },
    TRANSACTIONAMOUNTDIFFERS: {
        defaultMessage: 'Transaction Amount Differs',
        id: 'transactionAmountDiffers',
    },
    POINTOFINTERACTIONCURRENCYCONVERSION: {
        defaultMessage: 'Point-of-Interaction Currency Conversion',
        id: 'pointOfInteractionCurrencyConversion',
    },
    DUPLICATIONPAIDBYOTHERMEANS: {
        defaultMessage: 'Duplication/Paid by Other Means',
        id: 'duplicationPaidByOtherMeans',
    },
    ATMDISPUTES: {
        defaultMessage: 'ATM Disputes',
        id: 'atmDisputes',
    },
    LOSSTHEFTDAMAGES: {
        defaultMessage: 'Loss, Theft, or Damages',
        id: 'lossTheftDamages',
    },
    NOCARDHOLDERAUTHORIZATION: {
        defaultMessage: 'No Cardholder Authorization',
        id: 'noCardholderAuthorization',
    },
    QUESTIONABLEMERCHANTACTIVITY: {
        defaultMessage: 'Questionable Merchant Activity',
        id: 'questionableMerchantActivity',
    },
    EMVCHIPLIABILITYSHIFT: {
        defaultMessage: 'EMV Chip Liability Shift',
        id: 'EMVChipLiabilityShift',
    },
    EMVCHIPPINLIABILITYSHIFT: {
        defaultMessage: 'EMV Chip/PIN Liability Shift',
        id: 'EMVChipPINLiabilityShift',
    },
    CARDHOLDERDISPUTEOFARECURRINGTRANSACTION: {
        defaultMessage: 'Cardholder Dispute of a Recurring Transaction',
        id: 'cardholderDisputeOfARecurringTransaction',
    },
    GOODSORSERVICESNOTPROVIDED: {
        defaultMessage: 'Goods or Services Not Provided',
        id: 'goodsOrServicesNotProvided',
    },
    NOSHOWHOTELCHARGE: {
        defaultMessage: 'No-Show Hotel Charge',
        id: 'noShowHotelCharge',
    },
    ADDENDUMDISPUTE: {
        defaultMessage: 'Addendum Dispute',
        id: 'addendumDispute',
    },
    GOODSSERVICESNOTASDESCRIBEDORDEFECTIVE: {
        defaultMessage: 'Goods/Services not as Described or Defective',
        id: 'goodsServicesNotAsDescribedOrDefective',
    },
    DIGITALGOODS25ORLESS: {
        defaultMessage: 'Digital Goods $25 or less',
        id: 'DigitalGoods25OrLess',
    },
    COUNTERFEITGOODS: {
        defaultMessage: 'Counterfeit Goods',
        id: 'counterfeitGoods',
    },
    TRANSACTIONDIDNOTCOMPLETE: {
        defaultMessage: 'Transaction Did Not Complete',
        id: 'transactionDidNotComplete',
    },
    CREDITPOSTEDASAPURCHASE: {
        defaultMessage: 'Credit Posted as a Purchase',
        id: 'creditpostedAsAPurchase',
    },
    CARDHOLDERDISPUTENOTCLASSIFIEDELSEWHERE: {
        defaultMessage: 'Cardholder Dispute Not Classified Elsewhere',
        id: 'cardholderDisputeNotClassifiedElsewhere',
    },
    INSTALLMENTBILLINGDISPUTEPARTICIPATINGCOUNTRIESONLY: {
        defaultMessage:
            'Installment Billing Dispute (Participating Countries Only)',
        id: 'installmentBillingDisputeParticipatingCountriesOnly',
    },
    DOMESTICCHARGEBACKDISPUTEEUROPEREGIONONLY: {
        defaultMessage: 'Domestic Chargeback Dispute (Europe Region Only)',
        id: 'domesticChargebackDisputeEuropeRegionOnly',
    },
});

export default modality;
